import fetchAPI from "./fetchAPI"

export async function fetchAllWildNeighbors() {
  const { fetchAllWildNeighbors } = await fetchAPI(
    `#graphql
    query {
      fetchAllWildNeighbors {
          data
        }
      }`,
    {},
    true
  )

  return fetchAllWildNeighbors
}

export async function fetchWildNeighbors({ type = "token", token }) {
  const { fetchWildNeighbors } = await fetchAPI(
    `query($type: String, $token: String!) {
      fetchWildNeighbors(type: $type, token: $token) {
        message
        data
        }
      }`,
    {
      variables: { type, token }
    },
    true
  )

  return fetchWildNeighbors
}

export async function updateWildNeighbor({ token, form }) {
  const { updateWildNeighbor } = await fetchAPI(
    `mutation($token: String, $form: JSON!, ) {
        updateWildNeighbor(token: $token, form: $form, ) {
          success
          data
          location
          token
        }
      }`,
    {
      variables: {
        token,
        form
      }
    }
  )

  return updateWildNeighbor
}

export async function updateWildNeighborActivity({ token, index, form }) {
  const { updateWildNeighborActivity } = await fetchAPI(
    `mutation($token: String, $index: Int, $form: JSON!, ) {
        updateWildNeighborActivity(token: $token, index: $index, form: $form, ) {
          success
          data
          token
        }
      }`,
    {
      variables: {
        token,
        index,
        form
      }
    }
  )

  return updateWildNeighborActivity
}

export async function deleteWildNeighborActivity({ token, index }) {
  const { deleteWildNeighborActivity } = await fetchAPI(
    `mutation($token: String, $index: Int) {
        deleteWildNeighborActivity(token: $token, index: $index) {
          success
          data
          token
        }
      }`,
    {
      variables: {
        token,
        index
      }
    }
  )

  return deleteWildNeighborActivity
}

export async function confirmWildNeighbor({ token }) {
  const { confirmWildNeighbor } = await fetchAPI(
    `mutation($token: String!) {
        confirmWildNeighbor(token: $token) {
          status
        }
      }`,
    {
      variables: {
        token
      }
    }
  )

  return confirmWildNeighbor
}

export async function requestWildNeighborPassword({ token, email }) {
  const { requestWildNeighborPassword } = await fetchAPI(
    `mutation($token: String!, $email: String!) {
        requestWildNeighborPassword(token: $token, email: $email) {
          status
          message
        }
      }`,
    {
      variables: {
        token,
        email
      }
    }
  )

  return requestWildNeighborPassword
}
